
import {initWebComponent} from "@/helpers/web-component-helper";
import {hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";
import {initPrint} from "@/helpers/print/print-scales-helper";
import {isCesiumEnabled} from "@/modules/cesium/cesium";
import {initPrintCesium} from "@/helpers/print/cesium/print-cesium-helper";
import {getViewRotation} from "@/helpers/ol/ol-view";
import {showNotification} from "@/helpers/notification-helper";

const template = document.createElement('template');
template.innerHTML = `<header-button data-icon="fa fa-file-pdf" data-tooltip="openPrint"></header-button>`;

export class HeaderPrintComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {

            hideLayerInfoForm()

            if(getViewRotation() !== 0) {
                showNotification('Rotatie in printen wordt nog niet ondersteund', '', 'warning')
                return
            }

            if(isCesiumEnabled()) {
                const element = document.querySelectorAll('bookmark-print-cesium')[0]
                element.classList.remove('d-none')
                element.parentNode.classList.remove('d-none')

                initPrintCesium()
                return
            }

            const element = document.querySelectorAll('bookmark-print')[0]
            element.classList.remove('d-none')
            element.parentNode.classList.remove('d-none')

            initPrint()
        });
    }
}
